// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qp-0";